export default {
  ALL: 'ALL',
  UPCOMING: 'UPCOMING',
  PAST: 'PAST',
} as const
